module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "regular-form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.handleSubmit()
      }
    }
  }, [_c('attachments-field', {
    attrs: {
      "error": _vm.$attrs.errors.bill_template
    },
    on: {
      "change": _vm.handleSubmit
    },
    model: {
      value: (_vm.$attrs['bill-template']),
      callback: function($$v) {
        _vm.$set(_vm.$attrs, 'bill-template', $$v)
      },
      expression: "$attrs['bill-template']"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-27662e48","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/forms/bill_template/BillTemplateBlankForm.vue
// module id = 606
// module chunks = 0